var postingMenu = {};

postingMenu.init = function() {

  postingMenu.quickBanLabels = [
    lang.quickBanEmpty,
    lang.quickBanPurge,
    "Undetected Proxy"
  ];
  postingMenu.banLabels = [
    lang.ipBypassBan,
    lang.rangeBanOctets.replace('__octets__', '1/2'),
    lang.rangeBanOctets.replace('__octets__', '3/4'),
    lang.asnBan,
    lang.ipBypassWarning
  ];
  // Staff roles ruling 2026-10-18 (DESIGN §10 #10): the ban dialog is BUILT by
  // role — range (1,2) and ASN (3) endpoints are Admin+ (56af6ff), so the
  // choices are rendered Admin+ only. Option VALUES carry the engine banType
  // index; Global janitor and below get ip/bypass (0) + warning (4) only.
  postingMenu.modBanLabels = [
    lang.ipBypassBan,
    lang.ipBypassWarning
  ];
  postingMenu.deletionOptions = [
    lang.doNotDelete,
    lang.deletePost,
    lang.deletePostAndMedia,
    lang.deleteByIpBypass
  ];
  postingMenu.threadSettingsList = [ {
    label : lang.toggleLock,
    field : 'locked',
    parameter : 'lock'
  }, {
    label : lang.togglePin,
    field : 'pinned',
    parameter : 'pin'
  }, {
    label : lang.toggleCyclic,
    field : 'cyclic',
    parameter : 'cyclic'
  }, {
    label : lang.toggleAutosage,
    field : 'autoSage',
    parameter : 'autoSage'
  } ];

  document.body.addEventListener('click', function clicked(event) {

    if (postingMenu.shownPostingMenu) {
      postingMenu.shownPostingMenu.remove();
      delete postingMenu.shownPostingMenu;
      // Clicking the button that owns an open menu closes it (toggle-off) by
      // stopping propagation so the button's own onclick doesn't immediately re-open.
      // The icon is now a ::before glyph on the .extraMenuButton span (an <img> can't
      // render ::before), so clicks target the span — match that; keep "iconReport"
      // for the legacy <img> still in the DOM.
      if(event.target !== null && (event.target.className == "iconReport" || event.target.className == "extraMenuButton")) {
        event.stopPropagation();
      }
    }

  }, true);

  // Bottom bar staff links — hide first, then un-hide only what THIS account
  // may actually use, mirroring the engine's server-side gates exactly
  // (metaOps.getBoardManagementData / form/mod.js /
  // metaOps.getBoardModerationData) so nobody sees a link they'd be denied on
  // click. Roles count DOWN from power: 1=superadmin, 2=admin, 3=moderator,
  // >=4 regular user. Current board comes from the URL path (/elite/ or
  // /elite/res/N.html). Inline display:none outranks the mobile glyph CSS;
  // clearing it falls back to normal text (desktop) / glyph (mobile).
  // Note: globalBoardModeration is unset in general.json, so board management
  // = owner/volunteer of THIS board only (a global admin not on its staff
  // list is denied server-side — don't widen this without checking that).
  var staffLinks = [ 'linkManagement', 'linkMod', 'linkModeration' ];

  for (var s = 0; s < staffLinks.length; s++) {
    var staffLink = document.getElementById(staffLinks[s]);

    if (staffLink) {
      staffLink.style.display = 'none';
    }
  }

  // The bare '/' spans around those links have no class — mobile already
  // hides them via the >span:not(.divRefresh) rule, but on desktop a
  // separator touching only gated-off links dangles (the logged-out
  // " / Manage Board / " the operator saw). Hide it when every anchor
  // neighbor is hidden; a separator whose other side is the refresh-controls
  // group (thread page) stays for staff, since at least one link then shows.
  var contentLinks = document.getElementById('boardContentLinks');

  if (contentLinks) {
    // 2026-08-30: the staff row is now wrapped in .staffRow — its inner '/'
    // separators are no longer direct children, so scan both roots with the
    // same dangling rule.
    var sepRoots = [ contentLinks ];
    var staffRowEl = contentLinks.querySelector('.staffRow');

    if (staffRowEl) {
      sepRoots.push(staffRowEl);
    }

    for (var root = 0; root < sepRoots.length; root++) {
      var sepKids = sepRoots[root].children;

      for (var sep = 0; sep < sepKids.length; sep++) {
        var node = sepKids[sep];

      if (node.tagName !== 'SPAN' || node.textContent.trim() !== '/') {
        continue;
      }

      var prevNode = node.previousElementSibling;
      var nextNode = node.nextElementSibling;
      var anchorNeighbors = [ prevNode, nextNode ].filter(function(n) {
        return n && n.tagName === 'A';
      });

      if (anchorNeighbors.length > 0 && anchorNeighbors.every(function(n) {
        return n.style.display === 'none';
      })) {
        node.style.display = 'none';
      }
      }
    }
  }

  // Account fetch is UNCONDITIONAL (legacy PenumbraLynx behavior). Upstream
  // KohlNumbra wrapped this in api.isModDomain() (hostname starts with 'mod'
  // or === 'localhost') because over there the mod panel lives on a subdomain;
  // on any other hostname loggedIn/globalRole/moddedBoards never got set and
  // the whole mod block of the post menu (Ban, Preselection/quick-ban, Edit,
  // Delete-by-IP, ...) silently vanished for real mods. Anonymous users pay
  // one cheap no-op request; loggedIn is only ever set when the engine says
  // they are actually logged in.
  api.formApiRequest('account', {}, function gotLoginData(status, data) {

    if (status !== 'ok') {
      return;
    }

    postingMenu.loggedIn = true;

    postingMenu.globalRole = data.globalRole;
    postingMenu.noBanCaptcha = data.noCaptchaBan;

    postingMenu.moddedBoards = [];

    for (var i = 0; i < data.ownedBoards.length; i++) {
      postingMenu.moddedBoards.push(data.ownedBoards[i]);
    }

    for (i = 0; i < data.volunteeredBoards.length; i++) {
      postingMenu.moddedBoards.push(data.volunteeredBoards[i]);
    }

    // v6 mobile post line: un-hide the bulk-select .deletionCheckBox for
    // anyone who can moderate this site (globalRole < 4 = roles 1-3; lower is
    // more powerful, >= 4 is a regular user) or any board.
    // CSS key is body.staffView (_posting.scss, <=479px block).
    if (postingMenu.loggedIn
        && (postingMenu.globalRole < 4 || postingMenu.moddedBoards.length > 0)) {
      document.body.classList.add('staffView');
    }

    // Root-only verb: [U] (Unlink = file leaves the post and becomes an orphan
    // in media management) is root-only by operator ruling 2026-10-22. Server
    // cells have it stripped at render (LynxChan common.js:951 setUploadModElements),
    // but CLIENT-built cells wire both links for anyone (posting.js:832), so the
    // cosmetic gate lives here. Fail-closed: hidden until the account request
    // lands, so a lower tier never sees it while role is unknown.
    if (postingMenu.globalRole === 0) {
      document.body.classList.add('rootView');
    }

    // Un-hide the bottom bar staff links this account may use (see hide-first
    // block above for the gate sources). Pages without them no-op.
    var boardPath = location.pathname.split('/')[1] || '';
    var isBoardStaff = postingMenu.moddedBoards.indexOf(boardPath) >= 0;

    if (isBoardStaff) { // owner or volunteer of THIS board
      var manageLink = document.getElementById('linkManagement');

      if (manageLink) {
        manageLink.style.display = '';
      }
    }

    if (isBoardStaff || data.globalRole <= 3) { // board staff OR any global staff
      var modLink = document.getElementById('linkMod');

      if (modLink) {
        modLink.style.display = '';
      }
    }

    if (data.globalRole < 2) { // superadmin only — the dangerous board-level page
      var moderationLink = document.getElementById('linkModeration');

      if (moderationLink) {
        moderationLink.style.display = '';
      }
    }


  }, {}, true);

  var links = document.getElementsByClassName('linkSelf');

  for (var i = 0; i < links.length; i++) {
    postingMenu.setExtraMenu(links[i]);
  }

};

postingMenu.closeMenu = function() {
  if (postingMenu.shownPostingMenu) {
    postingMenu.shownPostingMenu.remove();
    delete postingMenu.shownPostingMenu;
  }
}

postingMenu.showReport = function(board, thread, post, callback) {

  var outerPanel = captchaModal.getCaptchaModal(lang.report2, api.noReportCaptcha);

  var categoriesCombobox = document.getElementById('reportComboboxCategory');

  var reasonField = document.createElement('input');
  reasonField.type = 'text';
  reasonField.placeholder = lang.optional;

  var globalSpan = document.createElement('span');
  var globalCheckbox = document.createElement('input');
  globalCheckbox.id = "globalCheckbox";
  globalCheckbox.type = 'checkbox';
  var globalLabel = document.createElement('label');
  var globalRulesLink = document.createElement('a');
  globalRulesLink.innerText = lang.globalRules;
  globalRulesLink.setAttribute('target', '_blank');
  globalRulesLink.href = '/.static/pages/globalRules.html';
  globalLabel.innerHTML = lang.violatesGlobalRules.replace('__globalRules__', globalRulesLink.outerHTML);
  globalLabel.setAttribute('for', globalCheckbox.id);
  globalSpan.appendChild(globalCheckbox);
  globalSpan.appendChild(globalLabel);

  if (categoriesCombobox) {

    var newCategoriesCombobox = categoriesCombobox.cloneNode(true);
    newCategoriesCombobox.id = null;

    categories.adjustGlobalCheckbox(globalCheckbox, newCategoriesCombobox.value);

    newCategoriesCombobox.onchange = function(e) {
      categories.adjustGlobalCheckbox(globalCheckbox, newCategoriesCombobox.value);
    };

  }

  var okButton = outerPanel.getElementsByClassName('modalOkButton')[0];

  okButton.onclick = function() {

    var params = {
      reasonReport : reasonField.value.trim(),
      globalReport : globalCheckbox.checked,
      action : 'report'
    };

    if (!api.noReportCaptcha) {

      var typedCaptcha = outerPanel.getElementsByClassName('modalAnswer')[0].value
        .trim();

      if (/\W/.test(typedCaptcha)) {
        alert(lang.invalidCaptcha);
        return;
      }

      params.captchaReport = typedCaptcha;

    }

    if (categoriesCombobox) {
      params.categoryReport = newCategoriesCombobox.options[newCategoriesCombobox.selectedIndex].value;
    }

    var key = board + '-' + thread;

    if (post) {
      key += '-' + post;
    }

    params[key] = true;

    api.formApiRequest('contentActions', params, function requestComplete(
        status, data) {

      if (status === 'ok') {
        outerPanel.remove();
        alert(lang.reportSuccess);
        callback();
      } else {
        alert(status + ': ' + JSON.stringify(data));
      }

    });

  };

  if (categoriesCombobox) {
    captchaModal.addModalRow('Category', newCategoriesCombobox);
  }
  captchaModal.addModalRow(lang.comment, reasonField, okButton.onclick);
  captchaModal.addModalRow(lang.global, globalSpan, okButton.onclick);

};

postingMenu.deleteSinglePost = function(boardUri, threadId, post, fromIp,
    unlinkFiles, wipeMedia, innerPart, forcedPassword, onThread, trash) {

  var key = boardUri + '/' + threadId

  if (post) {
    key += '/' + post;
  }

  var storedData = JSON.parse(localStorage.postingPasswords || '{}');

  var deletionFieldPassword = false;

  if (document.getElementById('deletionFieldPassword')) {
    deletionFieldPassword = document.getElementById('deletionFieldPassword').value.trim()
  }

  var password = forcedPassword || storedData[key]
      || localStorage.deletionPassword
      || deletionFieldPassword
      || Math.random().toString(36).substring(2, 10);

  var selectedAction;

  if (trash) {
    selectedAction = 'trash';
  } else if (fromIp === 'allBoards') {
    selectedAction = 'ip-deletion-all-boards';
  } else if (fromIp) {
    selectedAction = onThread ? 'thread-ip-deletion' : 'ip-deletion';
  } else {
    selectedAction = 'delete';
  }

  var params = {
    confirmation : true,
    password : password,
    deleteUploads : unlinkFiles,
    deleteMedia : wipeMedia,
    action : selectedAction
  };

  var key = boardUri + '-' + threadId;

  if (post) {
    key += '-' + post;
  }

  params[key] = true;

  var deletionCb = function requestComplete(status, data) {

    if (status !== 'ok') {
      alert(status + ': ' + JSON.stringify(data));
      return;
    }

    var data = data || {};

    var removed = data.removedThreads || data.removedPosts;

    if (unlinkFiles && removed) {

      innerPart.parentNode.classList.remove('multipleUploads');

      var uploadCells = innerPart.getElementsByClassName('uploadCell');

      for (var i = 0; i < uploadCells.length; i++) {

        dynDel.markUploadCellAsDeleted(uploadCells[i], true);

      }

    } else if (fromIp) {

      dynDel.markCellPostAsDeleted(innerPart.parentNode, true);

      if (confirm(lang.postingsDeleted)) {
        /* Post-history view (latestPostings): reload IP-anchored so the view
           survives deleting the anchor post and keeps showing the poster's
           REMAINING boards. The RAW ip is only ever in #fieldIp, which the
           engine renders at/below clearIpMinRole (VM + live: key absent = the
           default 0 = Root only). Never read .labelIp for this: above
           clearIpMinRole it carries the per-board DISPLAY HASH, and
           setIpAndPostMatch drops ?ip= for those ranks, which leaves a
           matchBlock with NO identity filter = the global latest-postings
           feed. VM-measured 2026-10-21: an Admin's delete-by-IP reload landed
           on 50 unrelated cells / 322 KB, which is the mod report "the history
           page is completely fucked / it kicks you back to the index".
           Above clearIpMinRole every delete is bin-bound, so the anchor doc
           SURVIVES the sweep and a plain reload of the anchor URL is the right
           reload for Admin/janitor: the engine re-resolves the ip from the
           trashed anchor and shows the poster's remaining postings. */
        var historyFieldIp = document.getElementById('fieldIp');
        var historyFieldDate = document.getElementById('fieldDate');
        var targetIp = historyFieldIp && historyFieldIp.value.trim();

        if (targetIp && historyFieldDate) {
          location = '/latestPostings.js?ip='
              + encodeURIComponent(targetIp)
              + '&date=' + encodeURIComponent(historyFieldDate.value);
        } else if (api.isBoard || !api.boardUri) {
          location.reload(true);
        } else {
          window.location.pathname = '/' + boardUri + '/';
        }
      }

    } else if (api.threadId && data.removedThreads) {
      window.location.pathname = '/' + boardUri + '/';
    } else if (removed) {

      // Staff/bin-bound delete: a trashed post must not stay visible to a
      // below-Root viewer (2026-10-20 ruling). Remove the cell in place, no
      // reload/scroll reset. Anons keep the dim "Post deleted" ghost (ruling
      // 19: their self-delete is a hard delete, the ghost self-heals on reload).
      if (document.body.classList.contains('staffView')) {
        var delCell = innerPart.closest('.postCell, .opCell');
        if (delCell) {
          delCell.parentNode.removeChild(delCell);
        }
      } else {
        dynDel.markCellPostAsDeleted(innerPart.parentNode, true);
      }

    } else if (!removed) {

      var newPass = prompt(lang.couldNotDeleteTryAnotherPassword);

      if (newPass) {
        postingMenu.deleteSinglePost(boardUri, threadId, post, fromIp,
          unlinkFiles, wipeMedia, innerPart, newPass, onThread, trash);
      }

    }

  };

  api.formApiRequest('contentActions', params, deletionCb);

};

postingMenu.applySingleBan = function(statusHideCheckbox, typedMessage, deletionOption,
    typedReason, typedCaptcha, banType, typedDuration, global, nonBypassable,
    boardUri, thread, post, innerPart, outerPanel) {


  localStorage.setItem('autoDeletionOption', deletionOption);

  var params = {
    action : deletionOption === 1 ? 'ban-delete' : 'ban',
    nonBypassable : nonBypassable,
    reasonBan : typedReason,
    captchaBan : typedCaptcha,
    banType : banType,
    duration : typedDuration,
    banMessage : typedMessage,
    hideBan : statusHideCheckbox,
    globalBan : global
  };

  var key = boardUri + '-' + thread;

  if (post) {
    key += '-' + post;
  }

  params[key] = true;

  api.formApiRequest('contentActions', params, function requestComplete(status,
      data) {

    if (status === 'ok') {

      if (!statusHideCheckbox) {

        var banMessageDiv = innerPart.getElementsByClassName('divBanMessage')[0];

        if (!banMessageDiv) {
          banMessageDiv = document.createElement('div');
          banMessageDiv.className = 'divBanMessage';
          innerPart.appendChild(banMessageDiv);
        }

        banMessageDiv.innerHTML = typedMessage
            || '(' + lang.userWasBannedForThisPost + ')';

      }

      outerPanel.remove();

      if (deletionOption > 1) {
        postingMenu.deleteSinglePost(boardUri, thread, post,
          deletionOption === 3, false, deletionOption === 2, innerPart);
      } else if (deletionOption) {
        innerPart.parentNode.remove();
      }

    } else {
      alert(status + ': ' + JSON.stringify(data));
    }
  });

};

postingMenu.banSinglePost = function(innerPart, boardUri, thread, post, global) {

  var useCaptcha = !(postingMenu.globalRole < 4 || postingMenu.noBanCaptcha);

  var outerPanel = captchaModal.getCaptchaModal(global ? 'Global ban' : 'Ban',
    !useCaptcha);

  var okButton = outerPanel.getElementsByClassName('modalOkButton')[0];

  var reasonField = document.createElement('input');
  reasonField.type = 'text';

  var durationField = document.createElement('input');
  durationField.type = 'text';
  durationField.value = '12h';

  var messageField = document.createElement('input');
  messageField.type = 'text';
  messageField.value = '(' + lang.userWasBannedForThisPost + ')';

  var hideCheckbox = document.createElement('input');
  hideCheckbox.type = 'checkbox';

  var typeCombo = document.createElement('select');

  // Role-built ban type list (ruling §10 #10): Admin+ sees the full arsenal,
  // everyone else ip/bypass + warning. Values = engine banType indices.
  var isAdmin = postingMenu.loggedIn && postingMenu.globalRole <= 1;
  var banLabelList = isAdmin ? postingMenu.banLabels : postingMenu.modBanLabels;
  var banTypeIndices = isAdmin ? [0, 1, 2, 3, 4] : [0, 4];

  for (var i = 0; i < banLabelList.length; i++) {

    var option = document.createElement('option');
    option.innerHTML = banLabelList[i];
    option.value = banTypeIndices[i];
    typeCombo.appendChild(option);

  }

  var deletionCombo = document.createElement('select');

  // Role-built deletion choices: media-purge is Root-only by engine
  // construction (adjustMediaDeletion clears it for trashed), so the option is
  // rendered Root-only; IP-sweep is janitor+ (volunteers endpoint-denied).
  var isGlobalStaff = postingMenu.loggedIn && postingMenu.globalRole <= 3;
  var isRoot = postingMenu.loggedIn && postingMenu.globalRole === 0;
  var deletionChoices = isRoot ? [0, 1, 2, 3] : (isGlobalStaff ? [0, 1, 3] : [0, 1]);

  for (var i = 0; i < deletionChoices.length; i++) {

    var option = document.createElement('option');
    option.innerHTML = postingMenu.deletionOptions[deletionChoices[i]];
    option.value = deletionChoices[i];
    deletionCombo.appendChild(option);

  }


  //deletionCombo.selectedIndex = +localStorage.autoDeletionOption;
  deletionCombo.selectedIndex = 0;

  var captchaField;
  if (useCaptcha) {
    captchaField = outerPanel.getElementsByClassName('modalAnswer')[0];
  }


  var nonBypassableCheckbox = document.createElement('input');
  nonBypassableCheckbox.type = 'checkbox';
  nonBypassableCheckbox.checked = true;

  var quickBanCombo = document.createElement('select');

  // The Purge preset drives an IP-sweep (deletion value 3) — render it only
  // where the sweep exists (janitor+), same optics rule.
  var quickBanChoices = isGlobalStaff ? postingMenu.quickBanLabels
      : [postingMenu.quickBanLabels[0], postingMenu.quickBanLabels[2]];

  for (var i = 0; i < quickBanChoices.length; i++) {

    var option = document.createElement('option');
    option.innerHTML = quickBanChoices[i];
    quickBanCombo.appendChild(option);

  }

  quickBanCombo.onchange = function() {
    if (quickBanCombo.value === lang.quickBanPurge) {
      durationField.value = "30d";
      deletionCombo.value = "3"; // delete by ip (board)
    } else if (quickBanCombo.value === "Undetected Proxy") {
      durationField.value = "1y";
      nonBypassableCheckbox.checked = false;
      reasonField.value = "Undetected Proxy";
      messageField.value = "(Undetected proxy was detected.)";
    } else {
      durationField.value = "12h";
      deletionCombo.value = "0";
    }
  };

  okButton.onclick = function() {

    var durationValue = durationField.value.trim()

    if (durationValue && !posting.validateDurationFormat(durationValue)) {
      alert("Ban duration does not match expected format.");
      return;
    }

    if (+deletionCombo.value !== 3 || quickBanCombo.value === lang.quickBanPurge
      || confirm(lang.confirmIpBypassDeletionBoard)) {

      postingMenu.applySingleBan(hideCheckbox.checked, messageField.value.trim(),
        +deletionCombo.value, reasonField.value.trim(), useCaptcha
            && captchaField.value.trim(), +typeCombo.value,
        durationValue, global, nonBypassableCheckbox.checked,
        boardUri, thread, post, innerPart, outerPanel);
    }

  };

  captchaModal.addModalRow(lang.quickBan, quickBanCombo);
  captchaModal.addModalRow(lang.reason, reasonField, okButton.onclick);
  captchaModal.addModalRow(lang.duration, durationField, okButton.onclick);
  captchaModal.addModalRow(lang.hideMessage, hideCheckbox);
  captchaModal.addModalRow(lang.message, messageField, okButton.onclick);
  captchaModal.addModalRow(lang.type, typeCombo);
  captchaModal.addModalRow(lang.deletionAction, deletionCombo);
  captchaModal.addModalRow(lang.nonBypassable, nonBypassableCheckbox);

};

postingMenu.spoilSinglePost = function(innerPart, boardUri, thread, post) {

  var params = {
    action : 'spoil'
  };

  var key = boardUri + '-' + thread;

  if (post) {
    key += '-' + post;
  }

  params[key] = true;

  api.formApiRequest('contentActions', params, function requestComplete(status,
      data) {

    // style exception, too simple
    api.localRequest('/' + boardUri + '/res/' + thread + '.json', function(
        error, data) {

      if (error) {
        return;
      }

      var thumbs = innerPart.getElementsByClassName('imgLink');

      for (var i = 0; i < thumbs.length; i++) {
        var thumb = thumbs[i].childNodes[0].src = '/spoiler.png';
      }

    });
    // style exception, too simple

  });

};

postingMenu.mergeThread = function(board, thread) {

  var destination = prompt(lang.mergeWithWhichThread, lang.threadId);

  if (!destination) {
    return;
  }

  destination = destination.trim();

  api.formApiRequest('mergeThread', {
    boardUri : board,
    threadSource : thread,
    threadDestination : destination
  }, function transferred(status, data) {

    if (status === 'ok') {
      window.location.pathname = '/' + board + '/res/' + destination + '.html';
    } else {
      alert(status + ': ' + JSON.stringify(data));
    }
  });

};

postingMenu.transferThread = function(boardUri, thread) {

  var destination = prompt(lang.transferToWhichBoard,
      lang.boardUriWithoutSlashes);

  if (!destination) {
    return;
  }

  destination = destination.trim();

  api.formApiRequest('transferThread', {
    boardUri : boardUri,
    threadId : thread,
    boardUriDestination : destination
  }, function transferred(status, data) {

    if (status === 'ok') {

      if (window.location.pathname == "/openReports.js" || /^\/\w+\/\d*/.test(window.location.pathname) || /\?boardUri=(\w+)$/.test(window.location.search))
      {
        var confirmationText = lang.threadMoved;
        confirmationText = confirmationText.replace('__boardUri__', boardUri);
        confirmationText = confirmationText.replace('__threadId__', thread);
        confirmationText = confirmationText.replace('__boardUri2__', destination);
        confirmationText = confirmationText.replace('__threadId2__', data);

        var refreshPage = confirm(confirmationText);

        if (refreshPage) {
          window.location.pathname = '/' + destination + '/res/' + data + '.html';
        } else {
          location.reload();
        }
      }


    } else {
      alert(status + ': ' + JSON.stringify(data));
    }
  });

};

postingMenu.updateEditedPosting = function(board, thread, post, innerPart, data) {

  innerPart.getElementsByClassName('divMessage')[0].innerHTML = data.markdown;

  var subjectLabel = innerPart.getElementsByClassName('labelSubject')[0];

  if (!subjectLabel && data.subject) {

    var pivot = innerPart.getElementsByClassName('linkName')[0];

    subjectLabel = document.createElement('span');
    subjectLabel.className = 'labelSubject';
    pivot.parentNode.insertBefore(subjectLabel, pivot);

    pivot.parentNode.insertBefore(document.createTextNode(' '), pivot);

  } else if (subjectLabel && !data.subject) {
    subjectLabel.remove();
  }

  if (data.subject) {
    subjectLabel.innerHTML = data.subject;
  }

};

postingMenu.getNewEditData = function(board, thread, post, innerPart) {

  api.localRequest('/' + board + '/res/' + thread + '.json', function(error,
      data) {

    if (error) {
      return;
    }

    data = JSON.parse(data);

    if (post) {

      for (var i = 0; i < data.posts.length; i++) {
        if (data.posts[i].postId === +post) {
          data = data.posts[i];
          break;
        }
      }

    }

    postingMenu.updateEditedPosting(board, thread, post, innerPart, data);

  });

};

postingMenu.editPost = function(board, thread, post, innerPart) {

  var parameters = {
    boardUri : board,
    threadId : thread
  };

  if (post) {
    parameters.postId = post;
  }

  api.formApiRequest('edit', {}, function gotData(status, data) {

    if (status !== 'ok') {
      alert(status);
      return;
    }

    var outerPanel = captchaModal.getCaptchaModal(lang.edit, true);

    var okButton = outerPanel.getElementsByClassName('modalOkButton')[0];

    var subjectField = document.createElement('input');
    subjectField.type = 'text';
    subjectField.value = data.subject || '';

    var messageArea = document.createElement('textarea');
    messageArea.setAttribute('rows', '5');
    messageArea.setAttribute('cols', '35');
    messageArea.setAttribute('placeholder', lang.message);
    messageArea.defaultValue = data.message || '';

    okButton.onclick = function() {

      var typedSubject = subjectField.value.trim();
      var typedMessage = messageArea.value.trim();

      if (typedSubject.length > 128) {
        alert(lang.subjectTooLong.replace('__limit__', 128));
      } else if (!typedMessage.length) {
        alert(lang.messageMandatory);
      } else {

        var parameters = {
          boardUri : board,
          message : typedMessage,
          subject : typedSubject
        };

        if (post) {
          parameters.postId = post;
        } else {
          parameters.threadId = thread;
        }

        // style exception, too simple
        api.formApiRequest('saveEdit', parameters, function requestComplete(
            status, data) {

          if (status === 'ok') {
            outerPanel.remove();
            postingMenu.getNewEditData(board, thread, post, innerPart);
          } else {
            alert(status + ': ' + JSON.stringify(data));
          }
        });
        // style exception, too simple

      }

    };

    captchaModal.addModalRow(lang.subject, subjectField, okButton.onclick);
    captchaModal.addModalRow(lang.message, messageArea);

  }, false, parameters);

};

postingMenu.toggleThreadSetting = function(boardUri, thread, settingIndex,
    innerPart) {

  api.localRequest('/' + boardUri + '/res/' + thread + '.json',
      function gotData(error, data) {

        if (error) {
          alert(error);
          return;
        }

        var data = JSON.parse(data);

        var parameters = {
          boardUri : boardUri,
          threadId : thread
        };

        for (var i = 0; i < postingMenu.threadSettingsList.length; i++) {

          var field = postingMenu.threadSettingsList[i];

          parameters[field.parameter] = settingIndex === i ? !data[field.field]
              : data[field.field];

        }

        api.formApiRequest('changeThreadSettings', parameters,
            function requestComplete(status, data) {

              if (status === 'ok') {
                api.resetIndicators({
                  locked : parameters.lock,
                  pinned : parameters.pin,
                  cyclic : parameters.cyclic,
                  autoSage : parameters.autoSage,
                  archived : innerPart
                      .getElementsByClassName('archiveIndicator').length
                }, innerPart);
              } else {
                alert(status + ': ' + JSON.stringify(data));
              }
            });

      });

};

postingMenu.addToggleSettingButton = function(extraMenu, board, thread, index,
    innerPart) {

  var toggleButton = document.createElement('div');
  toggleButton.innerHTML = postingMenu.threadSettingsList[index].label;
  toggleButton.onclick = function(event) {
    postingMenu.toggleThreadSetting(board, thread, index, innerPart);
    postingMenu.closeMenu();
    event.stopPropagation();
  };

  extraMenu.appendChild(toggleButton);

};

postingMenu.sendArchiveRequest = function(board, thread, innerPart) {

  api.formApiRequest('archiveThread', {
    confirmation : true,
    boardUri : board,
    threadId : thread
  }, function(status, data) {

    if (status === 'ok') {

      if (!api.threadId) {
        innerPart.parentNode.remove();
        return;
      }

      var lock = innerPart.getElementsByClassName('lockIndicator').length;
      var pin = innerPart.getElementsByClassName('pinIndicator').length;
      var cyclic = innerPart.getElementsByClassName('cyclicIndicator').length;

      api.resetIndicators({
        locked : lock,
        pinned : pin,
        cyclic : cyclic,
        archived : true
      }, innerPart);

    } else {
      alert(status + ': ' + JSON.stringify(data));
    }

  });

};

postingMenu.setExtraMenuThread = function(extraMenu, board, thread, innerPart) {

  if (postingMenu.globalRole <= 2) {

    var transferButton = document.createElement('div');
    transferButton.innerHTML = lang.transferThread;
    transferButton.onclick = function(event) {
      postingMenu.transferThread(board, thread);
      postingMenu.closeMenu();
      event.stopPropagation();
    };
    extraMenu.appendChild(transferButton);

  }

  for (var i = 0; i < postingMenu.threadSettingsList.length; i++) {
    postingMenu.addToggleSettingButton(extraMenu, board, thread, i, innerPart);
  }

  // Merge: janitor(3)+ (ruled §10 #10 — radius one thread, no bytes destroyed,
  // visible effect; kept off board volunteers).
  if (postingMenu.globalRole <= 3) {

    var mergeButton = document.createElement('div');
    mergeButton.innerHTML = lang.mergeThread;
    mergeButton.onclick = function(event) {
      postingMenu.mergeThread(board, thread);
      postingMenu.closeMenu();
      event.stopPropagation();
    };
    extraMenu.appendChild(mergeButton);

  }

  if (innerPart.getElementsByClassName('archiveIndicator').length) {
    return;
  }

  // Archive: engine gate is globalRole <= 2 (archiveOps.js:122) — rendering it
  // at janitor/board-vol was a dead button (optics rule §10 #10).
  if (postingMenu.globalRole <= 2) {

    var archiveButton = document.createElement('div');
    archiveButton.innerHTML = lang.archive;
    archiveButton.onclick = function(event) {

      if (confirm(lang.confirmArchive)) {
        postingMenu.sendArchiveRequest(board, thread, innerPart);
        postingMenu.closeMenu();
        event.stopPropagation();
      }

    };
    extraMenu.appendChild(archiveButton);

  }

};

postingMenu.setModFileOptions = function(extraMenu, innerPart, board, thread,
    post) {

  var spoilButton = document.createElement('div');
  spoilButton.innerHTML = lang.spoilFiles;
  spoilButton.onclick = function(event) {
    postingMenu.spoilSinglePost(innerPart, board, thread, post);
    postingMenu.closeMenu();
    event.stopPropagation();
  };
  extraMenu.appendChild(spoilButton);

  // Staff roles ruling 2026-10-18 (§10 #10): media byte-purge is Root-only by
  // engine construction (adjustMediaDeletion forces deleteMedia=false once the
  // delete is trash-capped), so the promise is rendered Root-only.
  if (postingMenu.globalRole > 0) {
    return;
  }

  var deleteMediaButton = document.createElement('div');
  deleteMediaButton.innerHTML = lang.deletePostAndMedia;
  extraMenu.appendChild(deleteMediaButton);
  deleteMediaButton.onclick = function(event) {
    postingMenu.deleteSinglePost(board, thread, post, false, false, true,
        innerPart);
    postingMenu.closeMenu();
    event.stopPropagation();
  };

};

postingMenu.setExtraMenuMod = function(innerPart, extraMenu, board, thread,
    post, hasFiles) {

  if (hasFiles) {
    postingMenu.setModFileOptions(extraMenu, innerPart, board, thread, post);
  }

  // IP sweeps: janitor(3)+ — board volunteers are endpoint-denied (56af6ff),
  // so per the optics rule the buttons are not rendered to them at all.
  if (postingMenu.globalRole <= 3) {

    var deleteByIpButton = document.createElement('div');
    deleteByIpButton.innerHTML = lang.deleteByIpBypass;
    deleteByIpButton.onclick = function(event) {

      if (confirm(lang.confirmIpBypassDeletionBoard)) {
        postingMenu.deleteSinglePost(board, thread, post, true, null, null,
            innerPart);
        postingMenu.closeMenu();
        event.stopPropagation();
      }

    };
    extraMenu.appendChild(deleteByIpButton);

    var deleteByIpOnThreadButton = document.createElement('div');
    deleteByIpOnThreadButton.innerHTML = lang.deleteByIpBypassOnThread;
    deleteByIpOnThreadButton.onclick = function(event) {

      if (confirm(lang.confirmIpBypassDeletionThread)) {
        postingMenu.deleteSinglePost(board, thread, post, true, null, null,
          innerPart, null, true);
        postingMenu.closeMenu();
        event.stopPropagation();
      }

    };
    extraMenu.appendChild(deleteByIpOnThreadButton);

  }

  /* Whole-site ip deletion. Global staff only (role <= 3): a board
     owner/volunteer's authority stops at their own board, and the engine
     enforces the same gate server-side. Double-confirm — this is the nuclear
     option (the poster's entire site history), and it replaces the old
     "click Delete by IP (board) once per board" workflow. */
  if (postingMenu.globalRole <= 3) {

    var deleteByIpAllBoardsButton = document.createElement('div');
    deleteByIpAllBoardsButton.innerHTML = lang.deleteByIpBypassAllBoards;
    deleteByIpAllBoardsButton.onclick = function(event) {

      if (confirm(lang.confirmIpBypassDeletionAllBoards)
          && confirm(lang.confirmIpBypassDeletionAllBoards2)) {
        postingMenu.deleteSinglePost(board, thread, post, 'allBoards', null,
            null, innerPart);
        postingMenu.closeMenu();
        event.stopPropagation();
      }

    };
    extraMenu.appendChild(deleteByIpAllBoardsButton);

  }

  var banButton = document.createElement('div');
  banButton.innerHTML = lang.ban;
  banButton.onclick = function(event) {
    postingMenu.banSinglePost(innerPart, board, thread, post);
    postingMenu.closeMenu();
    event.stopPropagation();
  };
  extraMenu.appendChild(banButton);

  if (postingMenu.globalRole <= 2) {

    var globalBanButton = document.createElement('div');
    globalBanButton.innerHTML = lang.globalBan;
    globalBanButton.onclick = function(event) {
      postingMenu.banSinglePost(innerPart, board, thread, post, true);
      postingMenu.closeMenu();
      event.stopPropagation();
    };
    extraMenu.appendChild(globalBanButton);

  }

  // Staff roles ruling 2026-10-18 (§10 #10, F5): Edit = Global volunteer (2)+.
  // Silent + irreversible (engine keeps no editedBy/editedAt); the engine gate
  // moved to <=2 with the board-staff branch dropped (editOps.js).
  if (postingMenu.globalRole <= 2) {

    var editButton = document.createElement('div');
    editButton.innerHTML = lang.edit;
    editButton.onclick = function(event) {
      postingMenu.editPost(board, thread, post, innerPart);
      postingMenu.closeMenu();
      event.stopPropagation();
    };
    extraMenu.appendChild(editButton);

  }

  var post2 = !post ? thread : post;

  var historyLink = document.createElement('a');
  var historyButton = document.createElement('div');
  historyButton.innerHTML = lang.history;
  historyLink.href = '/latestPostings.js?boardUri=' + board + (post2 === thread ? '&threadId=' : '&postId=') + post2;
  historyLink.appendChild(historyButton);
  extraMenu.appendChild(historyLink);

  var moderateLink = document.createElement('a');
  var moderateButton = document.createElement('div');
  moderateButton.innerHTML = lang.moderate;
  moderateLink.href = '/mod.js?boardUri=' + board + '&threadId=' + thread + '#' + post2;
  moderateLink.appendChild(moderateButton);
  extraMenu.appendChild(moderateLink);

  if (!post) {
    postingMenu.setExtraMenuThread(extraMenu, board, thread, innerPart);
  }

};

postingMenu.buildMenu = function(linkSelf, extraMenu) {

  var innerPart = linkSelf.closest('.innerOP, .innerPost');   /* two-row status line */
  var isHidden = innerPart.classList.contains('userHide');

  var href = linkSelf.href;

  var board, thread;

  if (href.indexOf('mod.js') < 0) {

    var parts = href.split('/');

    board = parts[3];

    var finalParts = parts[5].split('.');

    thread = finalParts[0];

  } else {

    var urlParams = new URLSearchParams(href.split('?')[1]);

    board = urlParams.get('boardUri');
    thread = urlParams.get('threadId').split('#')[0];

  }

  var post = href.split('#')[1];

  if (post === thread) {

    post = undefined;

  }

  if (typeof(hiding) !== 'undefined') {

    if (typeof(post) !== 'undefined') {

      var divMessage = linkSelf.closest('.innerOP, .innerPost').getElementsByClassName('divMessage')[0];

      var hidePostButton = document.createElement('div');
      hidePostButton.className = 'hidePostButton';
      hidePostButton.innerHTML = isHidden ? lang.unhidePost : lang.hidePost;
      hidePostButton.onclick = function(event) {
        hiding.hidePost(linkSelf, board, thread, post || thread, !isHidden);
        postingMenu.closeMenu();
        event.stopPropagation();
      };

    }

    var hideAfterReportFunction = post !== undefined ? function() {
      hiding.hidePost(linkSelf, board, thread, post || thread, true);
    } : function() {
      hiding.hideThread(linkSelf, board, thread);
    };

    var reportButton = document.createElement('div');
    reportButton.innerHTML = lang.report;
    reportButton.onclick = function(event) {
      postingMenu.showReport(board, thread, post, hideAfterReportFunction);
      postingMenu.closeMenu();
      event.stopPropagation();
    };

    extraMenu.appendChild(reportButton);

    if (typeof(post) !== 'undefined') {
      extraMenu.appendChild(hidePostButton);
    }

  }

  var deleteButton = document.createElement('div');
  deleteButton.innerText = !post ? lang.deleteThread : lang.deletePost;
  extraMenu.appendChild(deleteButton);
  deleteButton.onclick = function(event) {
    postingMenu.deleteSinglePost(board, thread, post, null, null, null,
        innerPart);
    postingMenu.closeMenu();
    event.stopPropagation();
  };

  // Staff roles §10 #10 + ruling 4 (operator report 2026-10-18): the explicit
  // "Trash" item is Root-only. Below Root every delete is ALREADY bin-bound
  // (adjustTrashOption), so the item adds no capability and only BETRAYS the
  // hidden evidence locker — Root's audit trail over everyone else. Root is
  // the one rung where trash ≠ delete (soft-with-evidence vs hard).
  if (postingMenu.loggedIn && postingMenu.globalRole === 0) {

    var trashButton = document.createElement('div');
    trashButton.innerText = !post ? lang.trashThread : lang.trashPost;
    extraMenu.appendChild(trashButton);
    trashButton.onclick = function(event) {
      postingMenu.deleteSinglePost(board, thread, post, null, null, null,
          innerPart, null, null, true);
      postingMenu.closeMenu();
      event.stopPropagation();
    };

  }

  var hasFiles = linkSelf.closest('.innerOP, .innerPost')
      .getElementsByClassName('panelUploads')[0];

  hasFiles = hasFiles && hasFiles.children.length > 0;

  // Unlink files = Root-only visibility (§10 #10): below Root the engine
  // trashes the whole post with files intact, so the button is a lie there.
  if (hasFiles && postingMenu.loggedIn && postingMenu.globalRole === 0) {

    var unlinkButton = document.createElement('div');
    unlinkButton.innerText = lang.unlinkFiles;
    extraMenu.appendChild(unlinkButton);
    unlinkButton.onclick = function(event) {
      postingMenu.deleteSinglePost(board, thread, post, false, true, null,
          innerPart);
      postingMenu.closeMenu();
      event.stopPropagation();
    };

  }

  if (postingMenu.loggedIn
      && (postingMenu.globalRole < 4 || postingMenu.moddedBoards.indexOf(board) >= 0)) {
    postingMenu.setExtraMenuMod(innerPart, extraMenu, board, thread, post,
        hasFiles);
  }

  // Post date at the bottom of this menu — mobile only (<=479px), where the
  // one-line status line hides .labelCreated. CSS keeps it hidden on desktop,
  // where the date stays inline in the title line. Appended last so it sits
  // below every action, mod options included.
  var created = innerPart.getElementsByClassName('labelCreated')[0];
  if (created && created.textContent.trim()) {
    var dateRow = document.createElement('div');
    dateRow.className = 'postMenuDate';
    // postDate.js captures the full-precision original in data-full BEFORE any
    // compact/verbose reformatting — prefer it so the menu keeps full precision
    // in both modes (locked: "full precision one tap away"). Without postDate.js
    // (desktop / no mobile match) dataset.full is unset and this is a no-op.
    dateRow.textContent = created.dataset.full || created.textContent;
    extraMenu.appendChild(dateRow);
  }

};

postingMenu.setExtraMenu = function(linkSelf) {

  var parentNode = linkSelf.closest('.opHead, .postInfo');   /* two-row status line: ! menu is a sibling row */
  var extraMenuButton = parentNode.getElementsByClassName('extraMenuButton');

  if (!extraMenuButton.length) {
    return;
  }

  extraMenuButton[0].onclick = function() {

    var extraMenu = document.createElement('div');
    extraMenu.className = 'floatingMenu extraMenu';

    extraMenuButton[0].appendChild(extraMenu);

    postingMenu.shownPostingMenu = extraMenu;

    postingMenu.buildMenu(linkSelf, extraMenu);

    // Keep the menu inside the CURRENT viewport (standard dropdown flip):
    // it opens downward by default (.extraMenu { top:-5px }), which pushes a
    // tall menu below the fold when the post sits near the bottom of the
    // screen — the full mod menu is ~13 rows and was unusable there on
    // phones. If opening down overflows the viewport AND there is more room
    // above the button, flip it to open upward (.openUp mirrors top->bottom).
    // If the menu is taller than EITHER side (small phone + full mod menu),
    // pick the larger side; the CSS max-height/overflow-y cap then keeps the
    // rest reachable by scrolling inside the menu.
    var rect = extraMenuButton[0].getBoundingClientRect();
    var spaceBelow = window.innerHeight - rect.bottom;
    var spaceAbove = rect.top;
    if (extraMenu.offsetHeight + 5 > spaceBelow && spaceAbove > spaceBelow) {
      extraMenu.classList.add('openUp');
    }

  };

};

postingMenu.init();
